import React from 'react';
import Modal from '@omilia/modal';
import { Form, Field } from 'react-final-form';
import Button, { ButtonGroup } from '@omilia/button';
import styled from 'styled-components';

import TextFieldFinalFormWrapper from 'components/TextFieldFinalFormWrapper';
import { Props } from './types';
import validate from './utils/validate';

const SForm = styled.form`
  align-items: flex-end;
  display: flex;
  flex-direction: column;
  flex: 1;
`;

const CreateNewContextModal = ({
  onSubmit,
  onClose,
  onCheckContextName,
}: Props) => (
  <Modal
    open
    shouldCloseOnBackdropClick
    shouldCloseOnEscPress
    glyph="contexts"
    title="Create Context"
    onClose={onClose}
  >
    <Form onSubmit={onSubmit}>
      {({ handleSubmit, invalid, submitting }) => (
        <SForm onSubmit={handleSubmit}>
          <Field
            component={TextFieldFinalFormWrapper}
            data-test="new-context-name"
            label="CONTEXT NAME"
            name="contextName"
            placeholder="Please type a name for the context"
            validate={value => validate(value, onCheckContextName)}
          />
          <ButtonGroup>
            <Button
              color="secondary"
              data-test="cancel-button"
              variant="text"
              onClick={onClose}
            >
              Cancel
            </Button>
            <Button
              color="primary"
              data-test="create-button"
              disabled={invalid}
              loading={submitting}
              type="submit"
              variant="contained"
            >
              Create
            </Button>
          </ButtonGroup>
        </SForm>
      )}
    </Form>
  </Modal>
);

export default CreateNewContextModal;
